export const searchColumns = [
  {
    type: 'selectInput',
    prop: 'search_value',
    label: '',
    selectKey: 'search',
    placeholder: 'Search..',
    width: '120',
    options: [
      { label: 'Reward No', value: 'reward_no' },
      { label: 'Reward Name', value: 'name' },
      { label: 'Term Of Use', value: 'term_of_use' },
    ]
  },
]